module.exports = __webpack_public_path__ + "d6cf9352c12d349bcf02343f8af86ba5.pdf";